import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { AddTaskFile, TaskFileParams, TaskFileWithPage } from '@app/interfaces/lm/task';
import { AddTicketFile, TicketFilesParams, TicketFileWithPage } from '@app/interfaces/lm/ticket';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketFileService {
    private moduleApi = environment.api.services.lm;
    private baseUrl = this.moduleApi;

    constructor(private http: HttpClient) {
    }

    async find(params: TaskFileParams): Promise<TicketFileWithPage> {
        return lastValueFrom(this.http.get<TicketFileWithPage>(`${this.baseUrl}/ticket-files`, {
            params: Object.assign(params),
        }));
    }

    async add(data: AddTicketFile): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/ticket-file`, data));
    }

    async remove(params: { ticketFileId: number | string }): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}/ticket-file`, {
            params: Object.assign(params)
        }));
    }
}
